import React, { useState } from "react";
import { Button, Checkbox, Col, Form, Row } from "antd";
import CommentBox from "../../../../../inboxItemPages/components/commentBox";
import TaskCheckedList from "../../../../../inboxItemPages/components/taskCheckedList";

import listingImage from "../../../../../../../../assets/images/listing-pic.jpeg";
import { collection, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../../../../../../../firebase";

function PropertyInformation({ itemId, listId, checkedItems }) {
  const isItemChecked = checkedItems[itemId.toString()]; // Convert itemId to string because keys in checkedItems are strings.

  const [isDisabled, setIsDisabled] = useState(isItemChecked);
  const tasksRef = collection(db, "tasks");
  const itemListRef = doc(tasksRef, "itemList");
  const assignedCollectionRef = collection(itemListRef, "Assigned");

  function handleUndefinedValues(obj) {
    const newObj = {};
    for (let key in obj) {
      newObj[key] = obj[key] === undefined ? false : obj[key];
    }
    return newObj;
  }
  const onFinish = async (values) => {
 
    console.log("Success:", values);
    values = handleUndefinedValues(values);
    const targetDocRef = doc(assignedCollectionRef, listId);

    try {
      const docSnapshot = await getDoc(targetDocRef);

      if (docSnapshot.exists()) {
        const data = docSnapshot.data();
        if (data && data.workItemList) {
          const updatedWorkItemList = data.workItemList.map((item) => {
            return {
              ...item,
              status:
                item.id == itemId && item.status == "incompleted"
                  ? "completed"
                  : item.status,
              details: item.id == itemId && values,
            };
          });

          await updateDoc(targetDocRef, {
            workItemList: updatedWorkItemList,
          });

          console.log("Document successfully updated!");
          setIsDisabled(true);
        } else {
          console.log("workItemList not found in the document!");
        }
      } else {
        console.log("Document does not exist!");
      }
    } catch (error) {
      console.error("Error updating document:", error);
    }
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  return (
    <div className="item-page">
      <Form
        className="item-page-container"
        colon={false}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Row gutter={[0, 24]}>
          <Col span={24}>
            <h3 className="blue-info-text">NEW STEP!!</h3>
          </Col>
          <Col span={24}>
            <p className="blue-info-text">
              make sure and check back after you list the home to ensure it is
              showing up on Zillow and the pics and description are correct. we
              have had several not showing up for some reason.
            </p>
          </Col>
          <Col span={24}>
            <p className="pink-info-text">
              Only post pictures that present the property in a "good light" we
              want to give a good impression of the property and the types of
              homes we list. If the pictures shows construction materials,
              property damage over overgrown yard do not use the picture. If you
              are not able to get any good pictures notify the broker.
            </p>
          </Col>
          <Col span={24}>
            <h3 className="blue-info-text">
              Update the following info on the property page in appfolio
            </h3>
          </Col>
          <Col span={24}>
            <Form.Item label="1" name="totalBedroomAndBathrooms" valuePropName="checked">
              <Checkbox>enter number of bedrooms and bathrooms</Checkbox>
            </Form.Item>
            <Form.Item label="2" name="sqFootage" valuePropName="checked">
              <Checkbox>enter the sq footage</Checkbox>
            </Form.Item>
            <Form.Item label="3" name="updateRent" valuePropName="checked">
              <Checkbox>
                update the rent and set the security deposit at $0 and make sure
                the description shows the deposit wavier program wording
              </Checkbox>
            </Form.Item>
            <Form.Item label="4" name="isPetsAllow" valuePropName="checked">
              <Checkbox>
                select no pets unless owner requests to allow pets
              </Checkbox>
            </Form.Item>
            <Form.Item label="5" name="setAvailableAfter30Days" valuePropName="checked">
              <Checkbox>set available date for 30 days from today</Checkbox>
            </Form.Item>
            <Form.Item label="6" name="verifyIfSharedMeters" valuePropName="checked">
              <Checkbox>
                verify if there are shared meters and if you need to add a
                charge to the listing for utilities or discuss option with owner
              </Checkbox>
            </Form.Item>
            <Form.Item label="7" name="isPostOnInternetAndWeb" valuePropName="checked">
              <Checkbox>click post to internet AND post to website</Checkbox>
            </Form.Item>
            <Form.Item label="8" name="readyForShowing" valuePropName="checked">
              <Checkbox>
                make sure you have put in an "ready for showing on" date is
                selected
              </Checkbox>
            </Form.Item>
            <Form.Item label="9" name="manageLockbox" valuePropName="checked">
              <Checkbox>
                make sure you have assigned a codebox in the "manage physical
                lockboxes" page
              </Checkbox>
            </Form.Item>
            <Form.Item label="10" name="listingPrice" valuePropName="checked">
              <Checkbox>
                DO NOT LIST A HOME FOR RENT EVEN AS COMING SOON UNTIL THE OWNER
                HAS GIVEN YOU A CONFIRMED LISTING PRICE IN WRITING or the broker
                has approved a price
              </Checkbox>
            </Form.Item>
          </Col>
          <Col span={24}>
            <p className="blue-info-text">
              add the text below to the end of your descriptions
            </p>
          </Col>
          <Col span={24}>
            <p className="blue-info-text red-info-heading">
              Non section 8 house
            </p>
          </Col>
          <Col span={24}>
            <p className="blue-info-text">
              We offer a $0 Security Deposit Move in option. This is a security
              deposit waiver program. Let us know if you have any questions
              about the program to save you money at move in. The monthly fee is
              based on the highest credit score in your household and will be a
              between 3% and 10% of your monthly rent each month plus a sign up
              fee of $50. You can also opt to pay the full security deposit at
              move in on some properties. You will need to pay your first months
              rent when approved if you opt for the Security Deposit Waiver
              program.
            </p>
          </Col>
          <Col span={24}>
            <p className="blue-info-text">
              This home does not accept housing assistance programs.
            </p>
          </Col>
          <Col span={24}>
            <p className="blue-info-text">
              Tenant is responsible for all utilities as well as lawn care.
            </p>
          </Col>
          <Col span={24}>
            <p className="blue-info-text">
              Integrity Oklahoma does not advertise on Craigslist or Facebook.
              We will never ask you to wire money or pay with gift cards. Please
              report Fraudulent ads to your Property Manager. Verify all
              information with one of our property managers which are listed on
              our website at integrityokc.com prior to leasing or paying any
              deposit for a property. The property owner will NEVER contact you
              to lease or view this home.
            </p>
          </Col>
          <Col span={24}>
            <p className="blue-info-text">
              We do not accept Zillow applications or any other third party
              applications. All applications must be processed through
              Integrityokc.com
            </p>
          </Col>
          <Col span={24}>
            <p className="blue-info-text">
              There is a Lease Prep fee of $75 that is due at the time of lease
              signing. Remember to set up a showing just visit integrityokc.com
              and fill out the contact us form on the property page for this
              home! We will then request some additional info to enable us to
              set up a showing with you right away!
            </p>
          </Col>
          <Col span={24}>
            <p className="blue-info-text red-info-heading">Section 8 homes</p>
          </Col>
          <Col span={24}>
            <p className="blue-info-text">
              We offer a $0 Security Deposit Move in option. This is a security
              deposit waiver program. Let us know if you have any questions
              about the program to save you money at move in. The monthly fee is
              based on the highest credit score in your household and will be a
              between 3% and 10% of your monthly rent each month plus a sign up
              fee of $50. You can also opt to pay the full security deposit at
              move in on some properties. You will need to pay your first months
              rent when approved if you opt for the Security Deposit Waiver
              program.
            </p>
          </Col>
          <Col span={24}>
            <p className="blue-info-text">
              This home accepts housing vouchers.
            </p>
          </Col>
          <Col span={24}>
            <p className="blue-info-text">
              Tenant is responsible for all utilities as well as lawn care.
            </p>
          </Col>
          <Col span={24}>
            <p className="blue-info-text">
              Integrity Oklahoma does not advertise on Craigslist or Facebook.
              We will never ask you to wire money or pay with gift cards. Please
              report Fraudulent ads to your Property Manager. Verify all
              information with one of our property managers which are listed on
              our website at integrityokc.com prior to leasing or paying any
              deposit for a property. The property owner will NEVER contact you
              to lease or view this home.
            </p>
          </Col>
          <Col span={24}>
            <strong className="blue-info-text">
              Add these images as a photo for any property you list. Do not make
              it the primary photo but include it
            </strong>
          </Col>
          <Col span={24}>
            <Row gutter={[0, 12]}>
              <Col span={24}>
                <Row gutter={[8, 0]}>
                  <Col span={3}>
                    <img className="listing-img" src={listingImage} alt="" />
                  </Col>
                  <Col>
                    <span>Download</span>
                  </Col>
                </Row>
              </Col>
              <Col span={24}>
                <Row gutter={[8, 0]}>
                  <Col span={3}>
                    <img className="listing-img" src={listingImage} alt="" />
                  </Col>
                  <Col>
                    <span>Download</span>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <p className="onclick-text">
              https://www.jotform.com/tables/220879186346063
            </p>
          </Col>
          <Col span={24}>
            <p>Property Checklist filled out by owner</p>
          </Col>
          <Col span={24}>
            <Row justify="end" gutter={[8, 0]}>
              <Col>
                <Button>Skip</Button>
              </Col>
              <Col>
                <Button type="primary" htmlType="submit" disabled={isDisabled}>
                  Completed
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <CommentBox />
          </Col>
          <Col span={24}>
            <TaskCheckedList />
          </Col>
        </Row>
      </Form>
    </div>
  );
}

export default PropertyInformation;
